import './Footer.css'
import companylogo from '../../assets/kmpslogo.png'
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';
const Footer=()=>{
    return(
        <div className='footer-main-container'>
           <div className='footer-main-inner-container'> 
            <div className='footer-company-details'>
                <div className='footer-company-details-logo'>
                    <img src={companylogo} />
                </div>
                <p className='footer-company-details-text'>
                Our IoT platform streamlines operations with real-time data monitoring, device control, and automation, offering a robust solution
                for optimizing performance across industries like industrial automation and energy management
                </p>
                <div className='footer-company-details-icons'>
                    <div className='footer-company-details-icon'><FacebookIcon style={{fontSize:"1.5rem"}}/></div>
                    <div className='footer-company-details-icon'><XIcon style={{fontSize:"1.3rem"}}/></div>
                    <div className='footer-company-details-icon'><LinkedInIcon style={{fontSize:"1.5rem"}}/></div>
                    <div className='footer-company-details-icon'><YouTubeIcon style={{fontSize:"1.5rem"}}/></div>
                    </div>
                </div>
                {/* <div className='footer-company-links-container'>
                    <div className='footer-company-links-header'>Company</div>
                    <p className='footer-company-link'>About Us</p>
                    <p className='footer-company-link'>Latest Project</p>
                    <p className='footer-company-link'>IT Solutions</p>
                    <p className='footer-company-link'>Digital Solutions</p>
                    <p className='footer-company-link'>Team Member</p>
                    <p className='footer-company-link'>Contact Us</p>
                </div>
                <div className='footer-company-links-container'>
                    <div className='footer-company-links-header'>Services</div>
                    <p className='footer-company-link'>IT Strategy</p>
                    <p className='footer-company-link'>Network Service</p>
                    <p className='footer-company-link'>Solution Aduits</p>
                    <p className='footer-company-link'>Business Intelligence</p>
                    <p className='footer-company-link'>Data Science</p>
                    <p className='footer-company-link'>Virtual Workstation</p>
                </div> */}
                <div className='footer-company-contact-container'>
                    <div className='footer-company-links-header'>Contact Info</div>
                    <p className='footer-company-contact-text'>Address : <span>KMPS Digi Infra Private Limited, Ground floor, SMC House, 1/2, 6th Cross Rd, 6th main, 6th Block, HMT Layout, Vidyaranyapura, Bengaluru, Karnataka 560097.</span></p>
                    <p className='footer-company-contact-text'>Phone : <span style={{fontSize:"0.9rem", fontWeight:"400"}}>9986483320</span></p>
                    <p className='footer-company-contact-text'>Email : <span style={{fontSize:"0.9rem", fontWeight:"400"}}>marketing@kmpsdi.com</span></p>
                    
                    <div className='footer-company-contact-email-continer'>
                        <input placeholder='Enter your email' className='footer-email-input'/>
                        <button className='subcribe-btm'>Subcribe Now</button>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default Footer